module.exports = __webpack_public_path__ + "img/MishyaRai-177.72479928.png";